export enum ContactTypeResponse {
  BUYER_KEY_CONTACTS = 'buyerKeyContacts',
  SELLER_KEY_CONTACTS = 'sellerKeyContacts',
}

export enum ActionType {
  ADD = 'add',
  DELETE = 'delete',
}
